import React from 'react'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { SummedCollectionValue } from 'support/displays'
import * as PopUp from 'support/utilities/popup'
import * as UI from 'ui'

export default function NotificationWidget () {
  return (
    <div className='notification-widget'>
      <Collection resourceName='notifications.notifications'>
        <PopUp.PopUp>
          <PopUp.OpenPopUpOnClick>
            <UI.NotificationIcon>
              <SummedCollectionValue name='amount' />
            </UI.NotificationIcon>
          </PopUp.OpenPopUpOnClick>
          <PopUp.PopUpElement skidding={10}>
            <div className='w-80 text-center relative bg-white border border-gray-200 shadow-lg rounded-md -ml-6 mt-4'>
              <div className='notification-widget__arrow' />
              <div className='overflow-hidden rounded-md divide-y divide-gray-200'>
                <ForEachModel>
                  <div className='w-full m-0 text-left px-5 py-5 relative cursor-pointer hover:bg-gray-100 text-sm'>
                    <Displays.Link name='url' target='_self' className='flex items-center'>
                      <div className='bg-primary-500 text-white text-center text-2xs flex-shrink-0 w-5 h-5 rounded-full mr-3 flex items-center justify-center font-medium'>
                        <Displays.Text name='amount' />
                      </div>
                      <UI.Text block className='h-5'>
                        <Displays.Text name='title' />
                      </UI.Text>
                    </Displays.Link>
                  </div>
                </ForEachModel>
              </div>
            </div>
          </PopUp.PopUpElement>
        </PopUp.PopUp>
      </Collection>
    </div>
  )
}
